import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import Isvg from 'react-inlinesvg';

import Slider from "react-slick";

import Range from 'rc-slider/lib/Range';
import Tooltip from 'rc-tooltip';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';
import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';

import DeletePrompt from '../components/deletePrompt';
import olx from '../assets/images/olx.png';

class CategoriesPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.handleDeletePrompt = this.handleDeletePrompt.bind(this);

        this.state = {
            categories: [],
            deletePrompt: null,
            deletePromptValue: null
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('categories', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                categories: data
            });
        });


        this.props.socketIOClient.emit('categories', {});
    }

    handleDeletePrompt(answer, val) {
        console.log(val);
        if (answer) {
            this.props.socketIOClient.emit('deleteCategory', { category: val });
            this.props.openDeletePrompt(null, null);

        } else {
            this.props.openDeletePrompt(null, null);
        }
    }

    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("categories");
    }



    render() {

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel panel-list">
                    <div>

                        <div className="title">
                            <h1>{this.props.translate('Categories')}</h1>

                            <div className="button-wrap">
                                <Link to='/categories/new' className="button" >{this.props.translate('Add new category')}</Link>
                            </div>
                            <h6>{this.props.translate('List of categories')}</h6>



                        </div>


                        <div className="table">
                            <table>
                                {/*<tr className="text-row">
                                    <th></th>

                                    <th>{this.props.translate('Name')}</th>
                                    <th>{this.props.translate('Alias')}</th>
                                    <th className="action-head">{this.props.translate('Action')}</th>
            </tr>*/}

                                {
                                    this.state.categories.map((category) => {
                                        return (
                                            <tr >
                                                <td>{category.name}</td>
                                                <td>{category.alias}</td>
                                                <td className="action">
                                                    <Link to={`/categories/${category._id}`} className="button" ><i className="mdi mdi-pencil"></i> </Link>
                                                    <Link to={`/categories/${category._id}/attributes`} className="button" ><i className="mdi mdi-checkbox-marked"></i> </Link>
                                                    {/*
                                                    <Link to={`/categories/${category._id}/scraper`} className="button" ><img src={olx} /> </Link>
                                                    */}
                                                    <button className="button" onClick={() => this.props.openDeletePrompt(category._id, this.handleDeletePrompt)}><i className="mdi mdi-delete"></i> </button>
                                                </td>
                                            </tr>


                                        )
                                    }
                                    )}

                            </table>

                        </div>


                    </div>

                </div>



            </div>
        );
    }
}

export default PageWithLayout(CategoriesPage);


// WEBPACK FOOTER //
// ./src/views/categoriesPage.js